<ng-container *ngIf="taskSheetToDo.length>0">
  <div class="sheetslist-subtitle" *ngIf="title"><span translate [innerHtml]="title"></span> :</div>
  <div class="sheetlist-wrapper">
    <div class="sheetlist-row" *ngFor="let task of taskSheetToDo">
      <div class="sheetlist-subwrap">
        @if (typeExercice === 'offsite') {
        <span class="sheet-title">{{ task.what.title }}</span>
        }
        @if (typeExercice === 'onsite') {
        <span class="sheet-title" [innerHTML]="exerciceSheetService.getContentValueByTypeContent('title', task.what.sheets[0].content)"></span>
        }
      </div>
      <button *ngIf="canDeleteTask" class="delete-btn" (click)="deleteTask(task)"></button>
    </div>
  </div>
</ng-container>